import React from "react";
import theme from "theme";
import { Theme, Image, LinkBox, Text, Link, Box, Structure, Section, Strong, Em, Icon } from "@quarkly/widgets";
import { Helmet } from "react-helmet";
import { GlobalQuarklyPageStyles } from "global-page-styles";
import { RawHtml, Override } from "@quarkly/components";
import * as Components from "components";
import { FaTelegram } from "react-icons/fa";
export default (() => {
	return <Theme theme={theme}>
		<GlobalQuarklyPageStyles pageUrl={"bot/onlayn-prodazha-tovarov-na-kanalakh-i-gruppakh"} />
		<Helmet>
			<title>
				Продажа товара в каналах и чатах в Телеграм
			</title>
			<meta name={"description"} content={"Показываем как можно продавать товар и услуги внутри Телеграм сразу с онлайн оплатой при помощи бот-магазина"} />
			<meta property={"og:title"} content={"Продажа товара в каналах и чатах в Телеграм"} />
			<meta property={"og:description"} content={"Показываем как можно продавать товар и услуги внутри Телеграм сразу с онлайн оплатой при помощи бот-магазина"} />
			<meta property={"og:image"} content={"https://uploads.quarkly.io/62ab65c921e43d0020961286/images/1.jpg?v=2022-12-25T20:50:47.139Z"} />
			<link rel={"shortcut icon"} href={"https://uploads.quarkly.io/62ab65c921e43d0020961286/images/ucoz%201.svg?v=2022-07-18T14:33:40.269Z"} type={"image/x-icon"} />
			<link rel={"apple-touch-icon"} href={"https://uploads.quarkly.io/62ab65c921e43d0020961286/images/ucoz%201.svg?v=2022-07-18T14:33:40.269Z"} />
			<link rel={"apple-touch-icon"} sizes={"76x76"} href={"https://uploads.quarkly.io/62ab65c921e43d0020961286/images/ucoz%201.svg?v=2022-07-18T14:33:40.269Z"} />
			<link rel={"apple-touch-icon"} sizes={"152x152"} href={"https://uploads.quarkly.io/62ab65c921e43d0020961286/images/ucoz%201.svg?v=2022-07-18T14:33:40.269Z"} />
			<link rel={"apple-touch-startup-image"} href={"https://uploads.quarkly.io/62ab65c921e43d0020961286/images/ucoz%201.svg?v=2022-07-18T14:33:40.269Z"} />
			<meta name={"msapplication-TileImage"} content={"https://uploads.quarkly.io/62ab65c921e43d0020961286/images/ucoz%201.svg?v=2022-07-18T14:33:40.269Z"} />
			<meta name={"msapplication-TileColor"} content={"#000000"} />
		</Helmet>
		<Structure
			cells-number-total="2"
			quarkly-title="Navbar"
			position="relative"
			z-index="3"
			nout-z-index="9"
			padding="12px 0px 12px 0px"
		>
			<Override
				slot="Content"
				grid-template-columns="5fr 3fr"
				nout-grid-template-columns="3fr 3fr"
				lg-grid-template-columns="1fr 2fr"
				md-grid-template-columns="1fr 2fr"
				sm-grid-template-columns="1fr"
			>
				<Override slot="cell-0">
					<LinkBox href="https://www.ucoz.ru/bot/" pointer-events="none">
						<Image src="https://uploads.quarkly.io/62ab65c921e43d0020961286/images/ucoz%201.svg?v=2022-07-18T14:33:40.269Z" display="block" />
					</LinkBox>
					<LinkBox flex-direction="row" href="/en" display="none" sm-display="flex">
						<Text
							color="#000000"
							text-decoration-line="initial"
							font="--menu"
							transition="--opacityOut"
							hover-opacity=".8"
							padding="5px 5px 5px 5px"
						>
							English
						</Text>
					</LinkBox>
					<Components.QuarklycommunityKitMobileSidePanel menuPosition="right" breakpoint="nout">
						<Override
							slot="Content"
							background="rgba(255, 255, 255, 0)"
							md-background="--background"
							padding="8px 16px 8px 16px"
							nout-z-index="9999"
							nout-background="--background"
						/>
						<Override slot="Button Icon" size="32px" />
						<Override
							slot="Button Text"
							nout-text-transform="uppercase"
							nout-font="normal 500 16px/200% &quot;Montserrat&quot;, sans-serif"
							nout-letter-spacing="1px"
							sm-display="flex"
							sm-align-items="center"
							sm-justify-content="center"
						>
							меню
						</Override>
						<Override slot="Wrapper" nout-z-index="9" />
						<Box
							width="100%"
							display="flex"
							grid-gap="20px"
							md-flex-direction="column"
							nout-flex-direction="column"
							nout-margin="20px 0px 0px 0px"
							nout-grid-gap="16px"
						>
							<Link
								href="https://www.ucoz.ru/bot/"
								color="#000000"
								font="--menu"
								text-decoration-line="initial"
								transition="--opacityOut"
								hover-opacity=".8"
								padding="5px 5px 5px 5px"
							>
								Магазин в Телеграм
							</Link>
							<Link
								href="/bot/#easy"
								color="#000000"
								text-decoration-line="initial"
								font="--menu"
								transition="--opacityOut"
								hover-opacity=".8"
								padding="5px 5px 5px 5px"
							>
								Возможности
							</Link>
							<Link
								href="/bot/#top"
								color="#000000"
								text-decoration-line="initial"
								font="--menu"
								transition="--opacityOut"
								hover-opacity=".8"
								padding="5px 5px 5px 5px"
							>
								Преимущества
							</Link>
							<Link
								href="/bot/#price"
								color="#000000"
								text-decoration-line="initial"
								font="--menu"
								transition="--opacityOut"
								hover-opacity=".8"
								padding="5px 5px 5px 5px"
							>
								Цены
							</Link>
							<Link
								href="/bot/#example"
								color="#000000"
								text-decoration-line="initial"
								font="--menu"
								transition="--opacityOut"
								hover-opacity=".8"
								padding="5px 5px 5px 5px"
							>
								Примеры
							</Link>
							<Link
								href="/bot/#faq"
								color="#000000"
								text-decoration-line="initial"
								font="--menu"
								transition="--opacityOut"
								hover-opacity=".8"
								padding="5px 5px 5px 5px"
							>
								FAQ
							</Link>
						</Box>
						<Box
							display="none"
							sm-display="flex"
							sm-flex-direction="column"
							sm-align-items="flex-start"
							sm-grid-gap="16px"
							sm-margin="16px 0px 0px 0px"
						>
							<Link
								href="/instrukciya"
								color="#000000"
								text-decoration-line="initial"
								font="--menu"
								transition="--opacityOut"
								hover-opacity=".8"
								sm-padding="5px 5px 5px 5px"
								sm-font="normal 700 14px/1.5 &quot;Montserrat&quot;, sans-serif"
							>
								Инструкция
							</Link>
							<Link
								href="https://t.me/uShopWebBot"
								color="--white"
								font="--button"
								text-decoration-line="initial"
								padding="12px 24px 12px 24px"
								background="--dark"
								border-radius="50px"
								transition="--opacityOut"
								hover-opacity=".8"
								target="_blank"
								md-padding="12px 20px 12px 20px"
								sm-align-self="center"
								sm-margin="20px 0px 0px 0px"
							>
								Создать веб-бота
							</Link>
						</Box>
					</Components.QuarklycommunityKitMobileSidePanel>
				</Override>
				<Override
					slot="Cell 0th"
					align-items="center"
					justify-content="flex-end"
					grid-gap="24px"
					display="flex"
					md-display="flex"
					md-grid-gap="16px"
					sm-align-items="center"
				/>
				<Override slot="cell-1">
					<Box
						min-width="100px"
						min-height="100px"
						align-items="center"
						justify-content="center"
						display="flex"
					>
						<Text
							color="--grey"
							text-decoration-line="initial"
							font="--menu"
							transition="--opacityOut"
							hover-opacity=".8"
							padding="5px 5px 5px 5px"
						>
							Ru
						</Text>
						<Link
							href="https://www.ucoz.com/bot/"
							color="#000000"
							text-decoration-line="initial"
							font="--menu"
							transition="--opacityOut"
							hover-opacity=".6"
							padding="5px 5px 5px 5px"
						>
							En
						</Link>
					</Box>
					<Link
						href="/bot/instrukciya/"
						color="--dark"
						text-decoration-line="initial"
						font="--menu"
						transition="--opacityOut"
						hover-opacity=".8"
						padding="5px 5px 5px 5px"
						pointer-events="auto"
						user-select="auto"
						cursor="pointer"
					>
						Инструкция
					</Link>
					<Components.ButtonBot />
				</Override>
				<Override slot="Cell 1" sm-display="none" />
			</Override>
		</Structure>
		<Section padding="140px 0 140px 0" background="linear-gradient(0deg,rgba(2, 2, 2, 0.58) 0%,rgba(2, 2, 2, 0.58) 100%),rgba(0, 0, 0, 0) url(https://images.unsplash.com/photo-1649005699461-0d81d1c481e3?ixlib=rb-4.0.3&q=85&fm=jpg&crop=entropy&cs=srgb&w=2000) center center/cover repeat scroll padding-box" sm-padding="120px 0 120px 0">
			<Override slot="SectionContent" align-items="flex-start" md-align-items="center" />
			<Text
				margin="0px 0px 0px 0px"
				font="--headline1"
				md-font="normal 800 32px/1.4 &quot;Montserrat&quot;, sans-serif"
				sm-font="normal 800 24px/1.4 &quot;Montserrat&quot;, sans-serif"
				color="--white"
				as="h1"
				md-text-align="center"
			>
				Возможности бота в каналах и группах
			</Text>
			<Text margin="8px 0px 48px 0px" font="--headline3" color="--white" md-text-align="center">
				Делаем интеграцию бот-магазина с каналами и чатами
			</Text>
			<Link
				href="https://t.me/uSportClothes"
				color="--white"
				font="--button"
				text-decoration-line="initial"
				padding="16px 28px 16px 28px"
				background="--primary"
				border-radius="50px"
				transition="background-color --transitionDuration-normal --transitionTimingFunction-easeOut 0s"
				hover-color="--dark"
				hover-background="--white"
				target="_blank"
				text-align="center"
			>
				Пример канал магазина
			</Link>
		</Section>
		<Section padding="60px 0 60px 0" sm-padding="30px 0 30px 0" md-padding="30px 0 90px 0">
			<Text
				id="shop"
				margin="0px 0px 14px 0px"
				font="--headline2"
				sm-font="normal 800 20px/130% &quot;Montserrat&quot;, sans-serif"
				as="h3"
				color="--dark"
			>
				Функционал интеграции канала и бота
			</Text>
			<Text margin="12px 0px 16px 0px" font="--base" sm-font="normal 500 14px/160% &quot;Montserrat&quot;, sans-serif" color="--dark">
				Одной из фишек нашего конструктора 
магазина uShopWebBot является мощная связка с каналами и группами Телеграм. Ни один другой конструктор не дает такой глубинной интеграции с ними.

В этой статье мы с вами рассмотрим варианты такой интеграции.
				<br />
				<br />
				Первое и самое главное, для того чтобы размещать товары у вас должен быть создан свой веб-бот и заполнен товаром, создать такого бота, вы можете по нашей инструкции:{" "}
				<Strong
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
				>
					<Link
						href="/bot/instrukciya/"
						color="--primary"
						text-decoration-line="initial"
						hover-text-decoration-line="underline"
						overflow-wrap="normal"
						word-break="normal"
						white-space="normal"
						text-indent="0"
						text-overflow="clip"
						hyphens="manual"
						user-select="auto"
						pointer-events="auto"
					>
						Как создать магазин в формате веб-бота Telegram
						<br />
					</Link>
				</Strong>
				<br />
				Если бот у вас уже создан, то вам нужно определится где именно вы будете размещать ссылку на ваш товар, например вы можете завести свой собственный Телеграм канал (
				<Em
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
				>
					для примера, если вы продаете коврики для йоги, вы можете создать канал про медитацию, писать о её пользе, возможно публиковать какие-то практики и пр., набив небольшую аудиторию на канале, вы сможете публиковать ссылку на покупку вашего товара, как это реализовано здесь:{" "}
					<Link
						href="https://t.me/uSportClothes"
						color="--primary"
						text-decoration-line="initial"
						hover-text-decoration-line="underline"
						overflow-wrap="normal"
						word-break="normal"
						white-space="normal"
						text-indent="0"
						text-overflow="clip"
						hyphens="manual"
						user-select="auto"
						pointer-events="auto"
					>
						@uSportClothes
					</Link>
				</Em>
				).
			</Text>
			<Text margin="12px 0px 16px 0px" font="--base" sm-font="normal 500 14px/160% &quot;Montserrat&quot;, sans-serif" color="--dark">
				Полная видео-инструкция по всем интеграциям канала с бот-магазином:
			</Text>
			<Components.QuarklycommunityKitYouTube margin="0px 0px 0px 0px" url="https://www.youtube.com/watch?v=bUS8XXZ5Qkc?showinfo=0&enablejsapi=1&origin=https://ucoz.ru/" />
			<Text
				id="shop"
				margin="30px 0px 14px 0px"
				font="--headline2"
				sm-font="normal 800 20px/130% &quot;Montserrat&quot;, sans-serif"
				as="h3"
				color="--dark"
			>
				📦 1. Открытие каталога внутри канала или чата
			</Text>
			<Text margin="12px 0px 16px 0px" font="--base" sm-font="normal 500 14px/160% &quot;Montserrat&quot;, sans-serif" color="--dark">
				Благодаря недавнему обновлению Телеграм теперь можно отправлять прямые ссылки на ваш каталог, ссылки вы можете размещать в канале или в чатах, пример такой ссылки есть в нашем канале:{" "}
				<Link
					href="https://t.me/uShopWeb/21"
					target="_blank"
					color="--primary"
					text-decoration-line="initial"
					hover-text-decoration-line="underline"
				>
					@uShopWeb
				</Link>
			</Text>
			<Components.QuarklycommunityKitVideo src="https://dolcefood.usite.pro/kataloginchannel.mp4" autoPlay playOnHover={false} />
			<Text margin="4px 0px 0px 0px" font="italic 500 16px/160% --fontFamily-googleMontserrat" sm-font="normal 500 14px/160% &quot;Montserrat&quot;, sans-serif" color="--grey">
				Открытие каталога прямо в Телеграм канале
			</Text>
			<Text margin="12px 0px 16px 0px" font="--base" sm-font="normal 500 14px/160% &quot;Montserrat&quot;, sans-serif" color="--dark">
				Чтобы создать такую ссылку, вам необходимо сделать следующее:
				<br />
				<br />
				1. Зайти в{" "}
				<Link
					href="https://t.me/BotFather"
					target="_blank"
					color="--primary"
					text-decoration-line="initial"
					hover-text-decoration-line="underline"
				>
					@Botfather
				</Link>
				{" "}и прописать команду /newapp
				<br />
				2. Выбрать юзернейм нашего бота-магазина
				<br />
				3. Отправить название магазина и описание
				<br />
				4. Загрузить аватар\изображение с размером 640x360px
				<br />
				5. Добавить Gif-картинку описывающую функционал вашего бота, если такой картинки нет, то можете пропустить этот шаг командой /empty
				<br />
				6. Отправить адрес вашего сайта, формата: 
https://
				<Strong
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
				>
					АдресВашегоСайта
				</Strong>
				/shop/telegram_shop
				<br />
				7. Установите ЧПУ-адрес бота по которой будет открываться каталог, в нашем примере мы поставили{" "}
				<Strong
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
				>
					menu
				</Strong>
				{" "}и ссылка выглядит как: t.me/SportClothesBot/menu
			</Text>
			<Text
				id="shop"
				margin="30px 0px 14px 0px"
				font="--headline2"
				sm-font="normal 800 20px/130% &quot;Montserrat&quot;, sans-serif"
				as="h3"
				color="--dark"
			>
				🛒 2. Прямая ссылка на страницу товара внутри каталога
			</Text>
			<Text margin="12px 0px 16px 0px" font="--base" sm-font="normal 500 14px/160% &quot;Montserrat&quot;, sans-serif" color="--dark">
				Помимо открытия каталога в каналах, вы можете давать ссылку на конкретный товар, который будет открываться внутри вашего веб-бота, пример такой ссылки:{" "}
				<Link
					href="https://t.me/Dolce_Bot/menu?startapp=product_15"
					target="_blank"
					color="--primary"
					text-decoration-line="initial"
					hover-text-decoration-line="underline"
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
				>
					https://t.me/Dolce_Bot/menu?startapp=product_15
				</Link>
				<br />
				<br />
				Эта ссылка работает, если активирована опция открытия каталога с первого пункта, а сама ссылка формируется так: https://t.me/
				<Strong>
					ИмяБота
				</Strong>
				/
				<Strong>
					menu
				</Strong>
				?startapp=product_
				<Strong>
					15
				</Strong>
				, где 15 это ID товара, а вместо{" "}
				<Strong>
					menu
				</Strong>
				, вы указываете тот адрес который вы указали в 7-ом пункте.
				<br />
				<br />
				Получить ID товара, вы можете
в{" "}
				<Strong>
					панель управления сайта - модуль "Интернет-магазин" - раздел "Управление товарами":
				</Strong>
			</Text>
			<Image
				src="https://uploads.quarkly.io/62ab65c921e43d0020961286/images/IDtovar.png?v=2023-01-21T20:29:09.276Z"
				display="block"
				border-width="1px"
				border-color="--color-dark"
				border-style="solid"
				srcSet="https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/IDtovar.png?v=2023-01-21T20%3A29%3A09.276Z&quality=85&w=500 500w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/IDtovar.png?v=2023-01-21T20%3A29%3A09.276Z&quality=85&w=800 800w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/IDtovar.png?v=2023-01-21T20%3A29%3A09.276Z&quality=85&w=1080 1080w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/IDtovar.png?v=2023-01-21T20%3A29%3A09.276Z&quality=85&w=1600 1600w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/IDtovar.png?v=2023-01-21T20%3A29%3A09.276Z&quality=85&w=2000 2000w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/IDtovar.png?v=2023-01-21T20%3A29%3A09.276Z&quality=85&w=2600 2600w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/IDtovar.png?v=2023-01-21T20%3A29%3A09.276Z&quality=85&w=3200 3200w"
				sizes="(max-width: 576px) 100vw,(max-width: 768px) 100vw,(max-width: 992px) 100vw,(max-width: 1200px) 100vw,100vw"
			/>
			<Text
				id="shop"
				margin="30px 0px 14px 0px"
				font="--headline2"
				sm-font="normal 800 20px/130% &quot;Montserrat&quot;, sans-serif"
				as="h3"
				color="--dark"
			>
				💳 3. Ссылка на оплату конкретного товара
			</Text>
			<Text margin="12px 0px 16px 0px" font="--base" sm-font="normal 500 14px/160% &quot;Montserrat&quot;, sans-serif" color="--dark">
				Благодаря Telegram Payments 2.0, которая пришла к нам вместе с WebApp, теперь можно размещать товары напрямую в каналах сразу с онлайн оплатой, при чем товар можно размещать как и в своих каналах, так и закупать рекламу в сторонних каналах.{" "}
				<br />
				<br />
				Например разместить продажу помады в каналах женской тематики. При нажатии на купить в вашем посте пользователя будет перекидывать сразу на форму оформления заказа, где он оставит свои контактные данные, после заполнения которых будет открываться онлайн оплата.
			</Text>
			<Components.QuarklycommunityKitVideo src="https://dolcefood.usite.pro/channelbuy.mp4" autoPlay={false} playOnHover={false} />
			<Text margin="12px 0px 16px 0px" font="--base" sm-font="normal 500 14px/160% &quot;Montserrat&quot;, sans-serif" color="--dark">
				<Strong
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
				>
					Важно!{" "}
				</Strong>
				Этот функционал работает только если у вас подключена онлайн оплата от Telegram
				<br />
				Для реализации этого функционала у нас есть отдельная полноценная инструкция:{" "}
				<Link
					href="/bot/delayem-magazin-v-telegram/"
					target="_blank"
					color="--primary"
					text-decoration-line="initial"
					hover-text-decoration-line="underline"
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
				>
					Читать
				</Link>
			</Text>
			<Text
				id="shop"
				margin="30px 0px 14px 0px"
				font="--headline2"
				sm-font="normal 800 20px/130% &quot;Montserrat&quot;, sans-serif"
				as="h3"
				color="--dark"
			>
				💬 4. Отправка товара в чаты/группы
				<br />
			</Text>
			<Components.QuarklycommunityKitVideo src="https://dolcefood.usite.pro/chat.mp4" autoPlay playOnHover={false} />
			<Text margin="20px 0px 16px 0px" font="--base" sm-font="normal 500 14px/160% &quot;Montserrat&quot;, sans-serif" color="--dark">
				Помимо работы с каналами, товар можно отправлять в чаты с большим количеством участников, а также в личные сообщения своим потенциальным покупателям.
				<br />
				<br />
				Чтобы у вас был доступен этот функционал, вам необходимо сделать следующее:
				<br />
				<br />
				1. Зайти в{" "}
				<Link
					href="https://t.me/BotFather"
					target="_blank"
					color="--primary"
					text-decoration-line="initial"
					hover-text-decoration-line="underline"
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
				>
					@Botfather
				</Link>
				{" "}и прописать команду /mybots
				<br />
				2. Выбрать вашего бота и перейти в раздел "Bot Settings"
				<br />
				3. В этом разделе выбрать пункт "Inline Mode"
				<br />
				4. И активировать эту настройку нажав на переключатель "Turn on"
				<br />
				5. Дальше ждать, настройки вступают в силу до суток
				<br />
				<br />
				<Em
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
				>
					Этот функционал работает только в том случае, если у вас есть активная платежная система от Телеграм
				</Em>
			</Text>
		</Section>
		<Section background="--dark" padding="125px 0 125px 0" nout-padding="60px 0 60px 0" position="relative">
			<Override
				slot="SectionContent"
				display="flex"
				align-items="flex-start"
				md-align-items="center"
				md-justify-content="center"
				md-text-align="center"
			/>
			<Text
				margin="0px 0px 24px 0px"
				color="--white"
				font="--headline1"
				nout-font="normal 800 36px/1.4 &quot;Montserrat&quot;, sans-serif"
				lg-font="normal 800 26px/1.4 &quot;Montserrat&quot;, sans-serif"
				md-font="normal 800 22px/1.4 &quot;Montserrat&quot;, sans-serif"
				md-text-align="center"
				sm-font="normal 800 20px/1.4 &quot;Montserrat&quot;, sans-serif"
				as="h2"
			>
				Заказать бота интернет-магазин в Телеграм за 4000 руб.
			</Text>
			<Text
				margin="0px 0px 48px 0px"
				color="--white"
				font="--decsr"
				md-font="normal 500 16px/180% &quot;Montserrat&quot;, sans-serif"
				md-text-align="center"
				sm-font="normal 500 14px/180% &quot;Montserrat&quot;, sans-serif"
			>
				Создание сайтов, магазинов, порталов и лендингов под ключ. Помощь по сайтам,
				<br />
				SEO-продвижение и консультации с вебмастерами.
			</Text>
			<Link
				href="https://bot.divly.pro/"
				color="--white"
				font="--button"
				text-decoration-line="initial"
				padding="16px 28px 16px 28px"
				background="--primary"
				border-radius="50px"
				transition="background-color --transitionDuration-normal --transitionTimingFunction-easeOut 0s"
				hover-color="--dark"
				hover-background="--white"
				target="_blank"
			>
				Заказать веб-бот под ключ
			</Link>
		</Section>
		<Section
			background="--dark"
			padding="15px 0 15px 0"
			border-style="solid"
			border-color="--color-white"
			border-width="1px 0px 0px 0px"
			position="relative"
		>
			<Override
				slot="SectionContent"
				display="flex"
				align-items="center"
				flex-direction="row"
				grid-gap="16px"
				justify-content="space-between"
				md-flex-direction="column"
				md-align-items="center"
			/>
			<Box>
				<Text margin="0px 0px 0px 0px" color="--white" font="--base">
					<Link
						href="https://ukit.group/"
						color="--white"
						text-decoration-line="initial"
						target="_blank"
						hover-text-decoration-line="underline"
						padding="5px 5px 5px 5px"
					>
						© uKit Group
					</Link>
				</Text>
			</Box>
			<Box
				display="flex"
				grid-gap="32px"
				sm-flex-direction="column"
				sm-display="flex"
				sm-grid-gap="8px"
			>
				<Link
					href="https://www.ucoz.ru/details/"
					color="--white"
					font="--base"
					target="_blank"
					text-decoration-line="initial"
					hover-text-decoration-line="underline"
					sm-text-align="center"
					padding="5px 5px 5px 5px"
				>
					Юридическая информация
					<Link href="https://www.ucoz.ru/details/" />
				</Link>
				<Link
					href="https://www.ucoz.ru/terms/"
					color="--white"
					font="--base"
					target="_blank"
					text-decoration-line="initial"
					hover-text-decoration-line="underline"
					sm-text-align="center"
					padding="5px 5px 5px 5px"
				>
					Условия использования
				</Link>
			</Box>
			<LinkBox href="https://t.me/uShopWeb" target="_blank" transition="--opacityOut" hover-opacity="0.7">
				<Icon category="fa" icon={FaTelegram} size="24px" color="--white" />
			</LinkBox>
		</Section>
		<Components.EmbedHTML />
		<RawHtml>
			<style place={"endOfHead"} rawKey={"62ab65c921e43d0020961284"}>
				{":root {\n  box-sizing: border-box;\n}\n\n* {\n  box-sizing: inherit;\n    scroll-behavior: smooth;\n}\nbody {\n    position: relative !important;\n}"}
			</style>
			<script place={"endOfBody"} rawKey={"639c57f598af799c2def4641"}>
				{"   (function(m,e,t,r,i,k,a){m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)};\n   m[i].l=1*new Date();\n   for (var j = 0; j < document.scripts.length; j++) {if (document.scripts[j].src === r) { return; }}\n   k=e.createElement(t),a=e.getElementsByTagName(t)[0],k.async=1,k.src=r,a.parentNode.insertBefore(k,a)})\n   (window, document, \"script\", \"https://mc.yandex.ru/metrika/tag.js\", \"ym\");\n\n   ym(91719479, \"init\", {\n        clickmap:true,\n        trackLinks:true,\n        accurateTrackBounce:true,\n        webvisor:true\n   });"}
			</script>
			<script place={"endOfHead"} rawKey={"65b906fcebf1ff7fe82ff95a"}>
				{"(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':\nnew Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],\nj=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=\n'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);\n})(window,document,'script','dataLayer','GTM-59QRNH');"}
			</script>
			<script async={true} src={"//code.jivo.ru/widget/EsmX5tZp4R"} place={"endOfHead"} rawKey={"69b7f73f921c1a779c7c2cc6"} />
		</RawHtml>
	</Theme>;
});